import React, { FunctionComponent } from 'react'
import { AssettrakAccess } from 'server'
import { Switch, App, Form, Space } from 'antd'
import { useFeathersClient } from '@strac/react-client-feathers'

interface IProps {
  assettrakAccess: AssettrakAccess
}

const AccessDetails: FunctionComponent<any> = (props: IProps) => {
  const { assettrakAccess } = props

  const client = useFeathersClient()

  const { notification } = App.useApp()

  const handleChange = (value: boolean, field: string) => {
    client
      .service('assettrak-access')
      .patch(assettrakAccess.id, {
        [field]: value
      })
      .then((response: any) => {
        notification.success({
          message: 'Success',
          description: 'Access updated'
        })
      })
      .catch((error: any) => {
        notification.error({
          message: 'Error',
          description: error.message
        })
      })
  }

  return (
    <Form>
      <Space direction={'horizontal'}>
        <Form.Item label={'Agency Admin'}>
          <Switch
            checked={assettrakAccess.agency_admin}
            onChange={(value: boolean) => handleChange(value, 'agency_admin')}
          />
        </Form.Item>
        <Form.Item label={'System Admin'}>
          <Switch
            checked={assettrakAccess.system_admin}
            onChange={(value: boolean) => handleChange(value, 'system_admin')}
          />
        </Form.Item>
      </Space>
    </Form>
  )
}

export default AccessDetails
